document.querySelectorAll('[data-frest-featured-slider]').forEach((slider) => {
  const track = slider.querySelector('[data-featured-track]');
  const previous = slider.querySelector('[data-featured-previous]');
  const next = slider.querySelector('[data-featured-next]');

  if (!track || !previous || !next) return;

  const getStep = () => {
    const firstTile = track.querySelector('.frest-home__hero-tile');
    if (!firstTile) return track.clientWidth;
    const styles = window.getComputedStyle(track);
    return firstTile.getBoundingClientRect().width + Number.parseFloat(styles.columnGap || styles.gap || 0);
  };

  const updateControls = () => {
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll - 2;
    slider.classList.toggle('frest-home__featured-slider--static', maxScroll <= 2);
  };

  previous.addEventListener('click', () => track.scrollBy({ left: -getStep(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left: getStep(), behavior: 'smooth' }));
  track.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('resize', updateControls, { passive: true });
  updateControls();
});
